<template>
  <div class="LKMunMehList">
    <LKProgressCircular
      v-if="isLoadingAsyncData"
      overlay
      :size="50"
      style="align-items: start; padding-top: 30vh;"
    />

    <LKMunMehCardList
      v-else-if="list && list.length > 0"
      :list="list"
      :loading="isLoading"
      :pagination="pagination"
      :get-mun-meh="getOne"
      @change:next-page="onChangeNextPage"
    />

    <h4
      v-else
      v-text="'Список пуст'"
    />
  </div>
</template>

<script>
import { LkMunMehModel as Model } from './Model'
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { lkMunMehStoreModule as StoreModule } from './store'

import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import LKMunMehCardList from '@/views/LKMunMeh/components/LKMunMehCardList.vue'

const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

export default {
  name: 'LKMunMehList',
  components: {
    LKMunMehCardList,
    LKProgressCircular,
  },
  mixins: [listMixin],
}
</script>
